import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'

import {
  CreateMerchantDeviceTypes,
  CreateMerchantDeviceFormTypes,
  CreateMerchantDeviceFormSubmitValuesTypes,
  CreateMerchantDeviceFormSubmitActionsTypes,
} from 'types/merchant'
import useMerchantStore from 'store/merchant'

const CREATEMERCHANTDEVICEINITVAL: CreateMerchantDeviceTypes = {
  traderId: 0,
  deviceCode: '',
  deviceTypeId: 5,
  startDate: '',
  endDate: '',
  comments: '',
  username: '',
  password: '',
  flActive: 1
}

export const useCreateDevice = (
  onCloseModal: () => void
): {
  isLoading: boolean
  initialValues: CreateMerchantDeviceTypes
  handleSubmitCreateMerchantDevice: (
    values: CreateMerchantDeviceFormSubmitValuesTypes,
    actions: CreateMerchantDeviceFormSubmitActionsTypes
  ) => void
} => {
  const { traderId } = useParams()
  const queryClient = useQueryClient()
  const merchantTraderId = Number(traderId) || 0
  // MERCHANT CREATE DEVICE START
  const createMerchantDevice = useMerchantStore(
    (state) => state.createMerchantDevice
  )
  const merchantDeviceCreateLoading = useMerchantStore(
    (state) => state.merchantDeviceCreateLoading
  )
  // MERCHANT CREATE DEVICE END
  // MISC STATES START
  const [initialValues, initialValuesSet] =
    useState<CreateMerchantDeviceFormTypes>({
      ...CREATEMERCHANTDEVICEINITVAL,
      traderId: merchantTraderId,
    })
  // MISC STATES END

  const isLoading = useMemo(() => {
    return merchantDeviceCreateLoading ? true : false
  }, [merchantDeviceCreateLoading])

  const handleSubmitCreateMerchantDevice = useCallback(
    async (
      values: CreateMerchantDeviceFormSubmitValuesTypes,
      actions: CreateMerchantDeviceFormSubmitActionsTypes
    ) => {
      try {
        const payload = {
          ...values,
          startDate: values.startDate.slice(0, 10) + " 00:00:00",
          endDate: values.endDate.slice(0, 10) + " 23:59:59",
        }
        await createMerchantDevice(merchantTraderId, payload)
        toast.success('Merchant Device added successful.')
        queryClient.invalidateQueries({ queryKey: ['useMerchantDevices'] })
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        if (message.outcomeCode === 'HDA_MERCHANT:ADD_DEVICE:6. 6') {
          toast.error(`Merchant Device already exist.`)
        } else {
          toast.error(message.outcomeUserMessage)
        }
      }
    },
    [createMerchantDevice]
  )

  return {
    isLoading,
    initialValues,
    handleSubmitCreateMerchantDevice,
  }
}
